import React, { useEffect, useState } from 'react';
import TabsComponent from '@shared/components/tabs/tabs';
import {
  EditDialogSeriesFormProps,
  SeriesTabsEnum
} from '@modules/entertainment/models/series.model';
import { seriesTabData } from '@shared/utils/tabs.utils';
import SeriesDialogForm from './components/series-form/series-form';
import EpisodeTableContainer from '@modules/entertainment/pages/series/compnents/series-dialog-content/components/episode-table-container/episode-table-container.tsx';
import { LanguageEnum } from '@models/language.model.ts';
import useSeriesStore from '@modules/entertainment/pages/series/store/series.store.ts';

const EditDialogForm: React.FC<EditDialogSeriesFormProps> = ({
  selectedItem,
  handleClose,
  handleCreateOrUpdate,
  setCurrentDisplayTab,
  currentDisplayTab
}) => {
  const { getSeasonsList, setSeasonsListByLanguage } = useSeriesStore();
  const [isDisableTabs, setIsDisableTabs] = useState<boolean>(false);
  const [language, setLanguage] = useState<LanguageEnum>(LanguageEnum.English);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setCurrentDisplayTab(newValue);
  };

  useEffect(() => {
    if (selectedItem) setIsDisableTabs(false);
    else setIsDisableTabs(true);
  }, [selectedItem]);

  useEffect(() => {
    if (selectedItem && selectedItem._id) {
      getSeasonsList(selectedItem._id);
    }
  }, [selectedItem]);

  useEffect(() => {
    setSeasonsListByLanguage(language);
  }, [language]);

  return (
    <div>
      <TabsComponent
        tabs={seriesTabData}
        value={currentDisplayTab}
        onChange={handleTabChange}
        disabled={{
          media: isDisableTabs
        }}
      />

      {currentDisplayTab == SeriesTabsEnum.Details ? (
        <SeriesDialogForm
          selectedItem={selectedItem}
          handleClose={handleClose}
          onSave={handleCreateOrUpdate}
        />
      ) : (
        <EpisodeTableContainer
          language={language}
          setLanguage={setLanguage}
          selectedSerie={selectedItem}
        />
      )}
    </div>
  );
};

export default EditDialogForm;
